import { List } from '@material-ui/core/';
import { Deployment } from '../../../store/types';
import useSelect from '../../../store/hooks/useSelect';
import PageItem from './PageItem';
import Loader from './Loader';

const styles = {
  width: '30vw',
  minWidth: '400px',
  height: 'calc(100vh - 49px)',
  bgcolor: 'background.paper',
  overflow: 'scroll',
  py: 0,
};

interface IProp {
  list: Deployment[]
  loading?: boolean
}

export default ({ list, loading }: IProp) => {
  const { select } = useSelect();

  const PageItemsView = list.map((i) => <PageItem select={select} key={`key-${i.id}`} item={i} />);
  const ListView = <List sx={styles}>{PageItemsView}</List>;

  return loading ? <Loader /> : <>{ListView}</>;
};
